export enum LoanPageType {
    Landing = 0,
    LOC = 1,
    Construction = 2,
    Rental = 3,
    BuildRent = 4,
    FixFlip = 5,
    Land = 6,
    Model = 7,
    Bridge = 8,
}
